import {
  RadioButton,
  RadioButtonGroup,
  Tooltip,
} from 'carbon-components-react';
import React, { useEffect } from 'react';
import { segmentsTracking } from 'src/common/lib/tracker';
import './Step.scss';
import {
  convertToString,
  TranslationFunction,
} from 'src/common/hooks/widgets/useTranslation';

type CurrentUserProps = {
  pathSelected: string;
  setStatsPkg: React.Dispatch<React.SetStateAction<string>>;
  statsPkg: string;
  setIsRequired: React.Dispatch<React.SetStateAction<boolean>>;
  setQue1Value: React.Dispatch<React.SetStateAction<string>>;
  useTranslation: TranslationFunction;
};

const CurrentUser = ({
  pathSelected,
  setStatsPkg,
  statsPkg,
  setIsRequired,
  setQue1Value,
  useTranslation,
}: CurrentUserProps) => {
  const handleClick = (value: string) => {
    setIsRequired(false);
    setStatsPkg(value);
    setQue1Value('');
    segmentsTracking('CTA Clicked', {
      pageTitle: 'SPSS Purchasing Advisor Self Assessment',
      object: 'SPSS Purchasing Advisor Self Assessment page',
      resultValue: 'CTA clicked',
      CTA: 'License radio button selection',
      location: `${pathSelected} Assessment`,
      action: value,
      field: '',
    });
  };

  useEffect(() => {
    setIsRequired(true);
  }, []);

  return (
    <div>
      <div className="steps_styles">
        <div className="page_sub_heading_step">
          {useTranslation('spss_stats_ques_text')}
        </div>
        <div className="bx--row">
          <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
            <RadioButtonGroup
              name="Q1-NonTech-group"
              defaultSelected={statsPkg}
              orientation="vertical"
            >
              <RadioButton
                labelText={
                  <>
                    {useTranslation('spss_stats_ans1')}
                    <Tooltip
                      className="spss_tooltip"
                      onChange={() => {
                        segmentsTracking('CTA Clicked', {
                          pageTitle: 'SPSS Purchasing Advisor Self Assessment',
                          object:
                            'SPSS Purchasing Advisor Self Assessment page',
                          resultValue: 'CTA clicked',
                          CTA: 'Perpetual License tooltip',
                          location: `${pathSelected} Assessment`,
                          action: '',
                          field: '',
                        });
                      }}
                      direction={'top'}
                      tabIndex={0}
                    >
                      <span className="slide_text_step">
                        {useTranslation('landing_tooltip1_info1')}
                      </span>
                    </Tooltip>
                  </>
                }
                value={convertToString(useTranslation('spss_stats_ans1', true))}
                id="Q1A1"
                className="radio_text_step"
                onClick={() => handleClick('Perpetual License')}
              />
              <RadioButton
                labelText={
                  <>
                    {useTranslation('spss_stats_ans2')}
                    <Tooltip
                      onChange={() => {
                        segmentsTracking('CTA Clicked', {
                          pageTitle: 'SPSS Purchasing Advisor Self Assessment',
                          object:
                            'SPSS Purchasing Advisor Self Assessment page',
                          resultValue: 'CTA clicked',
                          CTA: 'Subscription License tooltip',
                          location: `${pathSelected} Assessment`,
                          action: '',
                          field: '',
                        });
                      }}
                      className="spss_tooltip tooltip-mt6"
                      direction={'top'}
                      tabIndex={0}
                      triggerText={''}
                    >
                      <span className="slide_text_step">
                        {useTranslation('landing_tooltip1_info2')}
                      </span>
                    </Tooltip>
                  </>
                }
                value={convertToString(useTranslation('spss_stats_ans2'))}
                id="Q1A2"
                className="radio_text_step"
                onClick={() => handleClick('Subscription License')}
              />

              <RadioButton
                labelText={
                  <>
                    {useTranslation('spss_stats_ans3')}
                    <Tooltip
                      onChange={() => {
                        segmentsTracking('CTA Clicked', {
                          pageTitle: 'SPSS Purchasing Advisor Self Assessment',
                          object:
                            'SPSS Purchasing Advisor Self Assessment page',
                          resultValue: 'CTA clicked',
                          CTA: 'SaaS Subscription License tooltip',
                          location: `${pathSelected} Assessment`,
                          action: '',
                          field: '',
                        });
                      }}
                      className="spss_tooltip"
                      direction={'top'}
                      tabIndex={0}
                      triggerText={''}
                    >
                      <span className="slide_text_step">
                        {useTranslation('landing_tooltip1_info3')}
                      </span>
                    </Tooltip>
                  </>
                }
                value={convertToString(useTranslation('spss_stats_ans3'))}
                id="Q1A3"
                className="radio_text_step"
                onClick={() =>
                  handleClick('Monthly & Annual Subscription License')
                }
              />
            </RadioButtonGroup>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CurrentUser;
